import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStaticAdsResponsive } from '../utils';

export class Ad extends Component {
  componentDidMount() {
  }

  render() {
    const { data } = this.props;
    const htlClass = data.teadsName ? `htlad-${data.slotName} teads-ad-wrapper` : `htlad-${data.slotName} incontent-ad-wrapper`;
    const slotTarget = data.teadsName ? `{"slot_name":"${data.teadsName}"}` : `{"slot_name":"${data.slotName}"}`

    return (
      <Fragment>
        { (data.teadsName == 'purewow_teads') && <div id='teads_after_me'></div> }
        { (data.teadsName == 'purewow_teads_2') && <div id='teads_after_me_2'></div> }
        <div 
          className={htlClass}
          data-unit={data.adUnit}
          data-targeting={slotTarget}>
        </div>
      </Fragment>
    );
  }
}

Ad.propTypes = {
  data: PropTypes.object,
};

export default Ad;
